import React, { type JSX } from 'react';
import { Input } from '../../../formik/Input';
import { RadioGroup } from '../../../formik/RadioGroup';
import { FormikValues, useFormikContext } from 'formik';
import {
  validateNotEqualTo,
  validateEmail,
  validatePhone,
  FORMIK_PUPIL_EMAIL,
  validateRequired
} from '../../../formik/validate.formik';

/**
 * The pupil section will only be shown when the user
 * selects the radio button 'Ik ben een ouder'.
 *
 * We want a nice animation to toggle these extra fields
 * hence we used a css class to show or hide the section.
 *
 * We use yup at the root of the form to only validate
 * these field if the fields are show.
 *
 * @example
 * <PupilFormSection/>
 */
export const PupilFormSection = (): JSX.Element => {
  const { values }: FormikValues = useFormikContext();
  const show: boolean = values.type === 'caretaker';

  return (
    <div className={`additional-fields px-3 ${show ? 'show': ''}`}>
      <h5>Gegevens leerling</h5>

      <div className="row">
        <div className="col-sm-12">
          <RadioGroup name="pupil.gender" items={[
            { value: 'male', label: 'Man' },
            { value: 'female', label: 'Vrouw' },
          ]} />
        </div>
      </div>
      <div className="row my-3">
        <div className="col-sm-4">
          <Input name='pupil.firstName' placeholder='Voornaam'/>
        </div>
        <div className="col-sm-4">
          <Input name='pupil.lastNamePrefix' placeholder='Tussenvoegsel'/>
        </div>
        <div className="col-sm-4">
          <Input name='pupil.lastName' placeholder='Achternaam'/>
        </div>
      </div>
      <div className="row my-3">
        <div className="col-sm-6">
          <Input name='pupil.mobile' placeholder='Telefoonnummer' validate={validatePhone}/>
        </div>
        <div className="col-sm-6">
          <div className="extra-info extra-info__indicator extra-info__show">*</div>
          <Input name='pupil.email' placeholder='E-mailadres' validate={(v: string): string => validateEmail(v)
            || validateNotEqualTo(v, values, 'caretaker.email', FORMIK_PUPIL_EMAIL)}/>
        </div>
      </div>
    </div>
  );
};
